import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { PopoverMenu } from '@gem/ui-kit';

import { PopupUserItem } from 'APP/main/Popups/GetParametersManager/components/PopupUserItem/PopupUserItem';
import PopupUserWithMenuItem from 'APP/main/Popups/GetParametersManager/components/PopupUserWithMenuItem';

import {
  IWorkspaceMembersListItemPresenterParams,
  useWorkspaceMembersListItemPresenter,
} from './WorkspaceMembersListItem.presenter';
import styles from './WorkspaceMembersListItem.styles.m.css';

type IWorkspaceMembersListItemProps = IWorkspaceMembersListItemPresenterParams;

export const WorkspaceMembersListItem: FC<IWorkspaceMembersListItemProps> = observer((props) => {
  const { member } = props;
  const { t } = useTranslation();
  const presenter = useWorkspaceMembersListItemPresenter(props);

  let hint = '';
  if (presenter.isOwner) {
    hint = t('common_owner_label');
  } else if (presenter.isAdmin) {
    hint = t('common_admin_label');
  }

  if (!presenter.isShowMenu) {
    return (
      <PopupUserItem
        user={member.user}
        hintClassName={styles.hintWithoutMenu}
        hint={hint}
        subtitleText={member.user.position}
        onClick={presenter.onClick}
      />
    );
  }

  return (
    <>
      <PopupUserWithMenuItem
        user={member.user}
        hint={hint}
        isOpenedMenu={presenter.isOpenedMenu}
        isMenuLoading={presenter.isMenuLoading}
        toggleMenu={presenter.onToggleMenu}
        onClick={presenter.onClick}
      />

      {presenter.menuItems.length && (
        <PopoverMenu
          isOpened={presenter.isOpenedMenu}
          placement="bottom-end"
          menuItems={presenter.menuItems}
          reference={presenter.menuReference}
          onClose={presenter.onCloseMenu}
        />
      )}
    </>
  );
});
